import {
  FORMLOAD,
} from 'store/types';

import { onError } from 'store/Notifier/actions';

export const setFormValues = (form, data, merge = true) => ({ type: FORMLOAD, merge: merge, payload: { [form]: data } });
